import type { PublicResearchMatchDetailResponse } from '~/features/worldcup-research/types'

const METRIC_KEY_MAPPING: Record<string, string> = {
  goals: 'goals',
  shotsTotal: 'total_shots',
  shotsOnTarget: 'shots_on_goal',
  corners: 'corner_kicks',
  expectedGoals: 'expected_goals',
  shotsOffTarget: 'shots_off_goal',
  shotsBlocked: 'blocked_shots',
  shotsInsideBox: 'shots_insidebox',
  shotsOutsideBox: 'shots_outsidebox',
  offsides: 'offsides',
  yellowCards: 'yellow_cards',
  redCards: 'red_cards',
  goalkeeperSaves: 'goalkeeper_saves',
  ballPossession: 'ball_possession',
  passesTotal: 'total_passes',
  passesAccurate: 'passes_accurate',
  passAccuracy: 'passes',
  apiFootballExpectedGoals: 'expected_goals',
  goalsPrevented: 'goals_prevented',
}

interface HalfTimeMetric {
  key: string
  homeFirstHalfValue?: unknown
  homeSecondHalfValue?: unknown
  awayFirstHalfValue?: unknown
  awaySecondHalfValue?: unknown
}

export function getPeriodMetricValue(
  metricKey: string,
  activeTab: 'ft' | '1h' | '2h',
  halfTimeRhythm: PublicResearchMatchDetailResponse['halfTimeRhythm'],
  side: 'home' | 'away',
  defaultValue: any,
): any {
  if (activeTab === 'ft' || !halfTimeRhythm || halfTimeRhythm.status !== 'available') {
    return defaultValue
  }

  const mappedKey = METRIC_KEY_MAPPING[metricKey]
  if (!mappedKey) {
    return null
  }

  const metric = (halfTimeRhythm.metrics as HalfTimeMetric[]).find(m => m.key === mappedKey)
  if (!metric) {
    return null
  }

  const period = activeTab === '1h' ? 'first_half' : 'second_half'
  if (side === 'home') {
    const val = period === 'first_half' ? metric.homeFirstHalfValue : metric.homeSecondHalfValue
    return val !== undefined ? val : null
  }
  else {
    const val = period === 'first_half' ? metric.awayFirstHalfValue : metric.awaySecondHalfValue
    return val !== undefined ? val : null
  }
}

export function classNames(...values: Array<string | false | undefined>) {
  return values.filter(Boolean).join(' ')
}

export function includeSelectedOption(
  options: Array<{ value: string, label: string }>,
  value: string,
  label = value,
) {
  if (!value || options.some(option => option.value === value)) {
    return options
  }
  return [...options, { value, label }]
}
